"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _flexEmbed = _interopRequireDefault(require("../flex-embed"));
var _imageSpaceHolder = _interopRequireDefault(require("./image-space-holder"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var OutOfViewportSpaceHolder = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var fallbackClassName = props.fallbackClassName,
    flexHeight = props.flexHeight,
    flexWidth = props.flexWidth,
    placeholder = props.placeholder,
    width = props.width,
    height = props.height,
    constrainStyle = props.constrainStyle,
    flexEmbedWrapperClassName = props.flexEmbedWrapperClassName;
  return placeholder && placeholder.src ? /*#__PURE__*/_react["default"].createElement(_imageSpaceHolder["default"], {
    fallbackClassName: fallbackClassName,
    height: height,
    placeholder: placeholder,
    ref: ref,
    width: width
  }) : /*#__PURE__*/_react["default"].createElement(_flexEmbed["default"], {
    className: flexEmbedWrapperClassName,
    height: flexHeight,
    ref: ref,
    style: constrainStyle,
    width: flexWidth
  });
});
OutOfViewportSpaceHolder.propTypes = process.env.NODE_ENV !== "production" ? {
  flexWidth: _propTypes["default"].number,
  flexHeight: _propTypes["default"].number,
  placeholder: _propTypes["default"].shape({
    alt: _propTypes["default"].string,
    src: _propTypes["default"].string
  }),
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  /* value is either object or null */
  constrainStyle: _propTypes["default"].any,
  fallbackClassName: _propTypes["default"].string,
  flexEmbedWrapperClassName: _propTypes["default"].string
} : {};
var _default = exports["default"] = OutOfViewportSpaceHolder;